<template>
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      width="32"
      height="32"
      fill="#DA291C"
    />
    <rect
      x="13"
      y="6"
      width="6"
      height="20"
      fill="#fff"
    />
    <rect
      x="6"
      y="13"
      width="20"
      height="6"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default { name: 'FlagCh' };
</script>
